import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import FileIcon from "../../../../media/FileIcon"
import { WorkflowFileProps } from "./WorkflowFile.types"
import "./WorkflowFile.css"
import { useEffect, useState } from "react"
import WorkflowType from "../../../../enums/workflowType"
import { getWorkflowTypeString } from "../../../../utils/utils"

const WorkflowFile = (props: WorkflowFileProps) => {
  const { 
    isSelected,
    onClick,
    onSelect,
    assetId,
    filename,
    workflowType,
    date,
    ellipsisMenu,
    enabled
  } = props

  const [showMenu, setShowMenu] = useState<boolean>(false)
  const [workflowTypeText, setWorkflowTypeText] = useState<string>("")

  useEffect(() => {
    setWorkflowTypeText(getWorkflowTypeString(workflowType))
  }, [workflowType])

  return (
    <div 
      className={`workflow-file-container ${isSelected ? "workflow-file-selected" : ""}`}
      onClick={enabled ? onSelect : () => {}}
      onDoubleClick={enabled ? onClick  : () => {}}
      style={{ opacity: enabled ? 1 : 0.4, cursor: enabled ? "pointer" : "wait" }}
    >
      <div className="pipe-id-container">
        <FileIcon />
        <p>{filename}</p>
      </div>

      <p>{assetId}</p>
      <p>{date}</p>
      <p>{workflowTypeText}</p>
      <div className="ellipsis-menu-container">
        <EllipsisMenu
          ellipsisMenu={
            {
              items: ellipsisMenu,
              showMenu: showMenu,
              onClick: () => enabled ? setShowMenu(true) : () => {},
              onHide: () => setShowMenu(false),
            } 
          }
        />
      </div>
    </div>
  )
}

WorkflowFile.defaultProps = {
  showHeader: false,
  isSelected: false
}

export default WorkflowFile